<div class="skk__modal upgrade-modal">
  <div class="skk__modal__top">
    <div class="skk__modal__top-content">
      <h3 class="skk__modal__title">
        <span i18n="@@upgradeModal.title.feature">{{ moduleLabel }} is part of</span>
        {{ requiredPlanName }}
      </h3>
      <button
        type="button"
        class="skk__modal__close"
        (click)="close()"
        i18n-aria-label="@@upgradeModal.closeButton.ariaLabel"
        aria-label="Close"
      >
        <i-lucide [img]="xIcon" aria-hidden="true" />
      </button>
    </div>
  </div>

  <div class="skk__modal__content upgrade-modal__content">
    <p class="upgrade-modal__sub">
      <span i18n="@@upgradeModal.subtitle.on">You're currently on </span
      ><strong>{{ currentPlanName() }}</strong
      >.
      <span i18n="@@upgradeModal.subtitle.upgrade"
        >Upgrade to {{ requiredPlanName }} to unlock {{ moduleLabel }}, plus everything else in the
        tier.</span
      >
    </p>

    <div class="upgrade-modal__gate-banner">
      <div class="upgrade-modal__feat-icon">
        <i-lucide [img]="moduleIcon" [size]="22" aria-hidden="true" />
        <span class="upgrade-modal__lock-badge">
          <i-lucide [img]="lockIcon" [size]="10" aria-hidden="true" />
        </span>
      </div>
      <div class="upgrade-modal__gate-info">
        <div class="upgrade-modal__gate-title">{{ moduleLabel }}</div>
        <div class="upgrade-modal__gate-sub" i18n="@@upgradeModal.gate.sub">
          The feature you just opened
        </div>
      </div>
      <span [class]="'skk__badge skk__badge--' + badgeVariant + ' upgrade-modal__plan-pill'">
        <i-lucide [img]="xIcon" [size]="10" style="display: none" aria-hidden="true" />
        {{ requiredPlanName }}
      </span>
    </div>

    @if (includedFeatures.length > 0) {
      <p class="upgrade-modal__also-label" i18n="@@upgradeModal.alsoIncluded">
        Also included in {{ requiredPlanName }}
      </p>
      <ul class="upgrade-modal__feat-list">
        @for (feature of includedFeatures; track feature.label) {
          <li class="upgrade-modal__feat-item">
            <span class="upgrade-modal__check">
              <i-lucide [img]="checkIcon" [size]="12" aria-hidden="true" />
            </span>
            <div>
              <strong>{{ feature.label }}</strong>
              <span>{{ feature.description }}</span>
            </div>
          </li>
        }
      </ul>
    }
  </div>

  <div class="skk__modal__buttons">
    <button type="button" class="btn btn--ghost" (click)="close()">
      <span i18n="@@upgradeModal.cancel">Maybe later</span>
    </button>
    <button type="button" class="btn btn--primary" (click)="goToPlan()">
      <span i18n="@@upgradeModal.upgrade">Upgrade plan</span>
    </button>
  </div>
</div>
